<confect-input
  [placeholder]="specItem.default"
  [title]="specItem.display"
  [ngModel]="value"
  (ngModelChange)="change($event)"
  [compact]="true"
  [icon]="specItem.icon"
/>
